const CANDIDATE_STATUSES = [
  'active',
  'disqualified'
];

export default CANDIDATE_STATUSES;
